import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils/utils';
import { DayPicker } from 'react-day-picker';
import { ChevronLeftIcon, ChevronRightIcon } from '../../../icons';
export const Calendar = ({ className, showOutsideDays = true, locale, ...props }) => {
    return (_jsx(DayPicker, { locale: locale, showOutsideDays: showOutsideDays, className: cn('w-fit tabular-nums', className), classNames: {
            months: 'relative flex',
            month_caption: 'relative mx-10 flex h-7 items-center justify-center',
            weekdays: 'flex flex-row gap-1',
            weekday: 'w-8 text-xs font-normal text-neutral-400',
            month: 'w-full',
            caption: 'relative flex items-center justify-center pt-1',
            caption_label: 'truncate text-sm font-medium',
            button_next: 'rounded-md hover:bg-neutral-200/50 cursor-pointer absolute h-7 z-10 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 right-0 flex justify-center items-center',
            button_previous: 'rounded-md hover:bg-neutral-200/50 cursor-pointer absolute h-7 z-10 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 left-0 flex justify-center items-center',
            nav: 'flex items-start',
            month_grid: 'mx-auto mt-3',
            week: 'mt-1 flex w-max items-start',
            day: 'flex size-9 rounded-md flex-1 items-center justify-center p-0 text-sm rounded-md hover:bg-neutral-200/50 cursor-pointer',
            day_button: 'size-9 p-0 font-normal !rounded-md transition-none aria-selected:opacity-100 disabled:cursor-default cursor-pointer',
            range_start: 'bg-neutral-200 [&>button]:bg-neutral-800 [&>button]:rounded-r-none [&>button]:text-white [&>button]:hover:bg-neutral-800 [&>button]:hover:text-white',
            range_middle: 'bg-neutral-200 !rounded-none [&>button]:hover:rounded-none !text-neutral-900 [&>button]:bg-transparent [&>button]:!text-neutral-900 [&>button]:hover:bg-neutral-200 [&>button]:hover:!text-white',
            range_end: 'bg-neutral-200 [&>button]:rounded-l-none [&>button]:bg-neutral-800 [&>button]:text-white [&>button]:hover:bg-neutral-800 [&>button]:hover:text-white',
            selected: '[&>button]:bg-neutral-800 [&>button]:text-white [&>button]:hover:bg-neutral-800 [&>button]:hover:text-white after:bg-white',
            today: 'relative after:block after:absolute after:size-[0.2rem] after:top-full after:-translate-y-1.5 after:bg-neutral-950 after:rounded-full',
            outside: 'day-outside text-neutral-400 opacity-50 aria-selected:bg-neutral-200/50 aria-selected:text-neutral-400 aria-selected:opacity-30',
            disabled: 'text-neutral-400 opacity-50 line-through select-none hover:bg-transparent',
            hidden: 'invisible flex-1'
        }, components: {
            Chevron: ({ orientation }) => {
                const Icon = orientation === 'left'
                    ? ChevronLeftIcon
                    : ChevronRightIcon;
                return _jsx(Icon, { className: "h-3 w-3" });
            }
        }, ...props }));
};
